import React, {useCallback, useState} from 'react';
import ButtonComponent from "../core/button/ButtonComponent";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface CopyComponentProps {
    duration?: number;
    beforeText?: string;
    afterText?: string;
    content: string;
    iconOnly?: boolean;
}

const CopyComponent = (props: CopyComponentProps) => {

        const duration = props.duration || 2000;
        const beforeText = props.beforeText || "Copy";
        const afterText = props.afterText || "Copied";
        const {content, iconOnly} = props;
        const [text, setText] = useState<string>(beforeText);
        const [isCopyButtonDisable, setCopyButtonDisable] = useState<boolean>(false);


        const copyToClipBoard = useCallback(() => {
            navigator.clipboard.writeText(content).then(() => {
                setText(afterText);
                setCopyButtonDisable(true);
                setTimeout(() => {
                    setText(beforeText)
                    setCopyButtonDisable(false)
                }, duration);
            });
        }, [content, afterText, beforeText, duration]);

        return (
            <ButtonComponent
                startIcon={!iconOnly ? <ContentCopyIcon/> : undefined}
                variant={iconOnly ? 'icon' : 'outlined'}
                color={'primary'}
                disabled={isCopyButtonDisable}
                handleClick={copyToClipBoard}
            >
                {iconOnly ? <ContentCopyIcon/> : text}
            </ButtonComponent>
        )
    }

;

export default CopyComponent;
